module.exports = __webpack_public_path__ + "static/img/tab-one.7d21501e.png";